import Vue from 'vue'
import App from './App.vue'
import router from '@/router/router'
import store from '@/store/index'
import VueCompositionApi from '@vue/composition-api'
import ElementUI from 'element-ui'
import Derectives from '@/directives/index'
import BaseComponent from '@/components/base/index'
import { isLt500 } from '@/utils/index'
import '@/assets/styles/reset.css'
import '@/assets/styles/override_element_ui.scss'
import '@/assets/styles/common.scss'
import '@/assets/styles/common1.scss'
// feedback
import { feedbackStarter } from '@/utils/feedbackEgine'
!isLt500() && feedbackStarter()

Vue.config.productionTip = false
Vue.use(VueCompositionApi)
Vue.use(ElementUI)
Vue.use(BaseComponent)
Vue.use(Derectives)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
